import React from 'react';
import Icon from '../../../components/AppIcon';

const CategoryFilter = ({ categories, activeCategory, onCategoryChange }) => {
  return (
    <div className="bg-card rounded-xl p-6 shadow-warm">
      <h3 className="font-serif text-xl font-semibold text-foreground mb-4">
        Browse by Category
      </h3>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
        {categories?.map((category) => (
          <button
            key={category?.id}
            onClick={() => onCategoryChange(category?.id)}
            className={`flex flex-col items-center gap-2 p-4 rounded-lg transition-all duration-300 ${
              activeCategory === category?.id
                ? 'bg-primary text-primary-foreground shadow-warm'
                : 'bg-muted hover:bg-muted/80 text-foreground'
            }`}
          >
            <div className={`w-12 h-12 rounded-lg flex items-center justify-center transition-all duration-300 ${
              activeCategory === category?.id
                ? 'bg-primary-foreground/20'
                : 'bg-background'
            }`}>
              <Icon 
                name={category?.icon} 
                size={24} 
                color={activeCategory === category?.id ? 'var(--color-primary-foreground)' : 'var(--color-primary)'}
              />
            </div>
            <span className="text-sm font-medium text-center">{category?.name}</span>
            <span className="text-xs opacity-70">{category?.count} items</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default CategoryFilter;